const { flatMap } = require('./arrays')
const formatPhoneMask = require('./masks')
const replaceSpecialChars = require('./removeCaracteres')
const removeHTML = require('./removeHTML')
const {
  slugfy,
  capitalize,
  htmlentities,
  serializeUrls,
  removeLastChar,
  formatTextToNumbers,
  normalizeText,
} = require('./strings')
const { isHome, isMobile, isUrl, isExternalLink } = require('./validators')
const getBackOfficeToken = require('./backofficeToken')
const mediaQuery = require('./mediaQuery')
const debounce = require('./debounce')
const {sendTeamsNotification,sendTeamsMessage} = require('./sendTeamsNotification')

module.exports = {
  flatMap,
  formatPhoneMask,
  replaceSpecialChars,
  removeHTML,
  slugfy,
  capitalize,
  htmlentities,
  serializeUrls,
  removeLastChar,
  formatTextToNumbers,
  normalizeText,
  isHome,
  isMobile,
  isUrl,
  isExternalLink,
  getBackOfficeToken,
  mediaQuery,
  // get,
  // set,
  debounce,
  sendTeamsNotification,
  sendTeamsMessage
}
